module.exports = __webpack_public_path__ + "0ff99711f4ded159bcadd590d6c53592.png";